import { render, staticRenderFns } from "./SidebarEditLeg.vue?vue&type=template&id=be54eeee&"
import script from "./SidebarEditLeg.vue?vue&type=script&lang=js&"
export * from "./SidebarEditLeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports